import React, { useState, useEffect, useCallback } from 'react';
import { Button } from './ui/button';
import { Play, Headphones } from 'lucide-react';
import api from '../services/api';

const Hero = () => {
  const [artistInfo, setArtistInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const heroImage = process.env.REACT_APP_HERO_IMAGE_URL || '';

  const fetchArtistInfo = useCallback(async () => {
    try {
      const response = await api.getArtistInfo();
      setArtistInfo(response.data);
    } catch (err) {
      console.error('Error fetching artist info:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchArtistInfo();
  }, [fetchArtistInfo]);

  if (loading) {
    return (
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0a1128]">
        <div className="text-white text-xl">Loading...</div>
      </section>
    );
  }

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${heroImage})`,
          filter: 'brightness(0.7)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a1128]/60 via-[#1e2749]/40 to-[#0a1128]" />

      <div className="relative z-10 container mx-auto px-6">
        <div className="max-w-4xl space-y-6 animate-fade-in">
          <div className="inline-block">
            <Headphones className="w-16 h-16 text-[#d4af37] mb-6 animate-pulse" />
          </div>
          <h1
            className="text-5xl md:text-7xl font-bold text-white mb-4 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {artistInfo?.name || 'VjkumarVarma'}
          </h1>
          <p className="text-2xl md:text-3xl text-[#d4af37] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            {artistInfo?.tagline || 'Lyricist & Music Producer'}
          </p>
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mb-2 leading-relaxed">
            {artistInfo?.bio || ''}
          </p>
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mb-8 leading-relaxed" style={{ fontFamily: 'Noto Sans Devanagari, sans-serif' }}>
            {artistInfo?.bioHindi || ''}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 items-start">
            <Button
              className="bg-[#d4af37] text-[#0a1128] hover:bg-[#c5a572] px-8 py-6 text-lg font-semibold transition-all duration-300 transform hover:scale-105"
              onClick={() => document.getElementById('discography')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <Play className="w-5 h-5 mr-2" />
              Explore Music
            </Button>
            <Button
              variant="outline"
              className="border-2 border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37] hover:text-[#0a1128] px-8 py-6 text-lg font-semibold transition-all duration-300 transform hover:scale-105"
              onClick={() => document.getElementById('lyrics')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Read Lyrics
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#d4af37] rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-[#d4af37] rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
